export const pickRandomColor = (index: number): [string, string] => {
  const colors: [string, string][] = [
    ["#D9A33D", "#A07422"],
    ["#6DA036", "#4D7522"],
    ["#34B0A9", "#228383"],
    ["#9B61C8", "#673B89"],
    ["#CF7575", "#7D4343"],
  ];
  let total_colors: [string, string][] = [...colors];
  
  if (index >= total_colors.length) {
    for (let i = 0; i <= index; i++) {
      total_colors.push(...colors);
    }
  }

  return total_colors[index];
};
